import { client, clientFile, clientBlob } from "service/service";
import { explodeIndicatorIdIndex } from "utils/utils";

export const getDocument = async (id: string) => {
  try {
    const res = await client.get(`documents/${id}`);
    return res.data;
  } catch (err) {
    throw err;
  }
};


export const getDocumentFile = async (id: string, format: string) => {
  try {
    const res = await clientBlob.get(`documents/${id}?format=${format}`, {
      responseType: 'blob'
    });
    return res;
  } catch (err) {
    throw err;
  }
  
};


export const getDocuments = async () => {
  try {
    const res = await client.get(`documents`);
    return res.data;
  } catch (err) {
    throw err;
  }
};

export const postCreateDocument = async ({ title, subtitle, description, code, documentId, isActive }: { title: string, subtitle: string, description: string, code: string, documentId: string, isActive: boolean }) => {
  try {
    const res = await client.post(`documents`, {
      title,
      subtitle,
      description,
      code,
      documentId,
      isActive
    });
    return res.data;
  } catch (err) {
    throw err;
  }
}

export const patchIndicatorsValues = async (documentId: string, targetId: string, subtargetId: string, timePeriod: string, indicators: any) => {

  try {
    const path = `documents/${documentId}/targets/${targetId}/subTargets/${subtargetId}/indicators/values/${timePeriod}`;
    const res = await client.patch(`${path}`, { indicators });
    return res.data;
  } catch (err) {
    throw err;
  }
}

export const patchIndicatorValues = async (documentId: string, targetId: string, subtargetId: string, actionId: string, indicatorId: string, timePeriod: string, values: any) => {
  try {
    const path = `documents/${documentId}/targets/${targetId}/subTargets/${subtargetId}/actions/${actionId}/indicators/${indicatorId}/values/${timePeriod}`;
    return client.patch(`${path}`, { values: values });
  } catch (err) {
    throw err;
  }
}


export const postIndicatorSource = async (documentId: string, id: string, file: any) => {

  try {
    const data = new FormData()
    data.append("file", file)
    const { targetIndex, subTargetId, actionId, indicatorId } = explodeIndicatorIdIndex(id);
    const apiPath = `documents/${documentId}/targets/${targetIndex}/subTargets/${subTargetId}/actions/${actionId}/indicators/${indicatorId}/attachments`;
    return clientFile.post(`${apiPath}`, data);
  } catch (err) {
    throw err;
  }
}

export const deleteIndicatorSource = async (documentId: string, id: string, filename: string) => {

  try {
    const { targetIndex, subTargetId, actionId, indicatorId } = explodeIndicatorIdIndex(id);
    const apiPath = `documents/${documentId}/targets/${targetIndex}/subTargets/${subTargetId}/actions/${actionId}/indicators/${indicatorId}/attachments/${filename}`;
    return clientFile.delete(`${apiPath}`);
  } catch (err) {
    throw err;
  }
}

export const patchTargets = async (documentId: string, targets: any) => {

  try {
    const path = `documents/${documentId}/targets`;
    return client.patch(`${path}`, { targets });
  } catch (err) {
    throw err;
  }
}

export const patchDocument = async (documentId: string, title: string, subtitle: string, description: string, code: string, isActive: string) => {

  try {
    const path = `documents/${documentId}`;
    return client.patch(`${path}`, {
      title,
      subtitle,
      description,
      code,
      isActive
    });
  } catch (err) {
    throw err;
  }
}

export const patchDocumentTargets = async (documentId: string, title: string, subtitle: string, description: string, code: string, targets: any) => {
  try {
    const path = `documents/${documentId}/targets`;
    const res = await client.patch(`${path}`, {
      title,
      subtitle,
      description,
      code,
      targets
    })
    return res.data;
  } catch (err) {
    throw err;
  }
}

export const patchDocumentTarget = async (documentId: string, targetId: string, target: any) => {

  try {
    const path = `documents/${documentId}/targets/${targetId}`;
    return client.patch(`${path}`, {
      ...target
    });
  } catch (err) {
    throw err;
  }
}

export const postDocumentTarget = async (documentId: string, target: any) => {

  try {
    const path = `documents/${documentId}/targets`;
    const res = await client.post(`${path}`, target);
    return res.data;
  } catch (err) {
    throw err;
  }
}

export const deleteDocumentTarget = async (documentId: string, targetId: string) => {
  try {
    const path = `documents/${documentId}/targets/${targetId}`;
    return client.delete(`${path}`);
  } catch (err) {
    throw err;
  }

}

export const patchDocumentSubtargets = async (documentId: string, targetId: string, subTargets: any) => {

  try {
    const path = `documents/${documentId}/targets/${targetId}/subTargets`;
    return client.patch(`${path}`, { ...subTargets });
  } catch (err) {
    throw err;
  }

}

export const postDocumentSubtarget = async (documentId: string, targetId: string, subTarget: any) => {

  try {
    const path = `documents/${documentId}/targets/${targetId}/subTargets`;
    const res = await client.post(`${path}`, subTarget);
    return res.data;
  } catch (err) {
    throw err;
  }
}


export const patchDocumentSubtarget = async (documentId: string, targetId: string, subTargetId: string, subTarget: any) => {
  try {
    const path = `documents/${documentId}/targets/${targetId}/subTargets/${subTargetId}`;
    return client.patch(`${path}`, { ...subTarget });
  } catch (err) {
    throw err;
  }
}

export const deleteDocumentSubtarget = async (documentId: string, targetId: string, subTargetId: string) => {
  try {
    const path = `documents/${documentId}/targets/${targetId}/subTargets/${subTargetId}`;
    return client.delete(`${path}`);
  } catch (err) {
    throw err;
  }
}

export const patchDocumentActions = async (documentId: string, targetId: string, subTargetId: string, actions: any) => {
  try {
    const path = `documents/${documentId}/targets/${targetId}/subTargets/${subTargetId}/actions`;
    return client.patch(`${path}`, { actions });
  } catch (err) {
    throw err;
  }

}

export const patchDocumentAction = async (documentId: string, targetId: string, subTargetId: string, actionId: string, action: any) => {
  try {
    const path = `documents/${documentId}/targets/${targetId}/subTargets/${subTargetId}/actions/${actionId}`;
    return client.patch(`${path}`, { ...action });
  } catch (err) {
    throw err;
  }
}

export const postDocumentAction = async (documentId: string, targetId: string, subTargetId: string, action: any) => {

  try {
    const path = `documents/${documentId}/targets/${targetId}/subTargets/${subTargetId}/actions`;
    const res = await client.post(`${path}`, { ...action });
    return res.data;
  } catch (err) {
    throw err;
  }
}

export const deleteDocumentAction = async (documentId: string, targetId: string, subTargetId: string, actionId: string) => {
  try {
    const path = `documents/${documentId}/targets/${targetId}/subTargets/${subTargetId}/actions/${actionId}`;
    return client.delete(`${path}`);
  } catch (err) {
    throw err;
  }
}

export const patchDocumentIndicators = async (documentId: string, targetId: string, subTargetId: string, actionId: string, indicators: any) => {

  try {
    const path = `documents/${documentId}/targets/${targetId}/subTargets/${subTargetId}/actions/${actionId}/indicators`;
    return client.patch(`${path}`, { indicators });
  } catch (err) {
    throw err;
  }

}

export const patchDocumentIndicator = async (documentId: string, targetId: string, subTargetId: string, actionId: string, indicatorId: string, indicator: any) => {

  try {
    const path = `documents/${documentId}/targets/${targetId}/subTargets/${subTargetId}/actions/${actionId}/indicators/${indicatorId}`;
    return client.patch(`${path}`, { ...indicator });
  } catch (err) {
    throw err;
  }

}

export const postDocumentIndicator = async (documentId: string, targetId: string, subTargetId: string, actionId: string, indicator: any) => {

  try {
    const path = `documents/${documentId}/targets/${targetId}/subTargets/${subTargetId}/actions/${actionId}/indicators?reindex=false`;
    const res = await client.post(`${path}`, { ...indicator });
    return res.data;
  } catch (err) {
    throw err;
  }

}

export const deleteDocumentIndicator = async (documentId: string, targetId: string, subTargetId: string, actionId: string, indicatorId: string) => {
  try {
    const path = `documents/${documentId}/targets/${targetId}/subTargets/${subTargetId}/actions/${actionId}/indicators/${indicatorId}`;
    return client.delete(`${path}`);
  } catch (err) {
    throw err;
  }
}


export const deleteDocument = async (documentId: string) => {
  try {
    const path = `documents/${documentId}`;
    return client.delete(`${path}`);
  } catch (err) {
    throw err;
  }
}

export const updateIndicatorsReindex = async (documentId: string, targetIndex: string, subtargetIndex: string, actionIndex: string, indicators: any[]) => {

  try {
    const path = `documents/${documentId}/targets/${targetIndex}/subTargets/${subtargetIndex}/actions/${actionIndex}/indicators?reindex=true`;
    return client.patch(`${path}`, { indicators });
  } catch (err) {
    throw err;
  }
}

export const updateActionsReindex = async (documentId: string, targetIndex: string, subtargetIndex: string, actionIndex: string, actions: any[]) => {
  try {
    const path = `documents/${documentId}/targets/${targetIndex}/subTargets/${subtargetIndex}/actions?reindex=true`;
    const res = await client.patch(`${path}`, { actions });
    return res.data;
  } catch (err) {
    throw err;
  }
}

export const updateSubtargetsReindex = async (documentId: string, targetIndex: string, subtargets: any[]) => {
  try {
    const path = `documents/${documentId}/targets/${targetIndex}/subTargets?reindex=true`;
    const res = await client.patch(`${path}`, { subtargets });
    return res.data;
  } catch (err) {
    throw err;
  }
}

export const updateTargetsReindex = async (documentId: string, targets: any[]) => {
  try {
    const path = `documents/${documentId}/targets?reindex=true`;
    const res = await client.patch(`${path}`, { targets });
    return res.data;
  } catch (err) {
    throw err;
  }
}
